import { useBoundStore } from 'useStore';
import FilterChip from 'views/Components/Forecast/FilterChip';
import useUsersData from 'views/Components/Shared/Queries/usersQuery';

export default function OwnerFilterChip() {
	const selectedOwner = useBoundStore((state) => state.fgSelectedOwner);
	const resetSelectedOwner = useBoundStore(
		(state) => state.resetFgSelectedOwner
	);
	const usersQuery = useUsersData();
	const owner = usersQuery.data?.find((m) => m.id === selectedOwner);

	if (selectedOwner === 0) return null;

	return (
		<FilterChip
			filterName="Owner"
			title={`${owner?.name} ${owner?.lastname}`}
			onDelete={() => resetSelectedOwner()}
		/>
	);
}
